"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProjectionDCF = exports.calculateDCFTerminalValueWeight = exports.calculateFairPriceDCF = void 0;
function calculateFairPriceDCF(totalFcf, growthRate, terminalGrowthRate, discountRate, years, cash, debt, sharesOutstanding) {
    var g1 = growthRate / 100;
    var g2 = terminalGrowthRate / 100;
    var r = discountRate / 100;
    if (r <= g2 || sharesOutstanding <= 0)
        return 0;
    var pvFcfSum = 0;
    for (var i = 1; i <= years; i += 1) {
        var fcfYear = totalFcf * Math.pow((1 + g1), i);
        pvFcfSum += fcfYear / Math.pow((1 + r), i);
    }
    var fcfLastYear = totalFcf * Math.pow((1 + g1), years);
    var terminalValue = (fcfLastYear * (1 + g2)) / (r - g2);
    var pvTerminal = terminalValue / Math.pow((1 + r), (years + 1));
    var enterpriseValue = pvFcfSum + pvTerminal;
    var equityValue = enterpriseValue + cash - debt;
    return equityValue / sharesOutstanding;
}
exports.calculateFairPriceDCF = calculateFairPriceDCF;
function calculateDCFTerminalValueWeight(totalFcf, growthRate, terminalGrowthRate, discountRate, years) {
    var g1 = growthRate / 100;
    var g2 = terminalGrowthRate / 100;
    var r = discountRate / 100;
    if (r <= g2 || !totalFcf)
        return 0;
    var pvFcfSum = 0;
    for (var i = 1; i <= years; i += 1) {
        var fcfYear = totalFcf * Math.pow((1 + g1), i);
        pvFcfSum += fcfYear / Math.pow((1 + r), i);
    }
    var fcfLastYear = totalFcf * Math.pow((1 + g1), years);
    var terminalValue = (fcfLastYear * (1 + g2)) / (r - g2);
    var pvTerminal = terminalValue / Math.pow((1 + r), years);
    var total = pvFcfSum + pvTerminal;
    if (total <= 0)
        return 0;
    return (pvTerminal / total) * 100;
}
exports.calculateDCFTerminalValueWeight = calculateDCFTerminalValueWeight;
function calculateProjectionDCF(totalFcf, growthRate, terminalGrowthRate, discountRate, years, t, cash, debt, sharesOutstanding) {
    var fairPrice = calculateFairPriceDCF(totalFcf, growthRate, terminalGrowthRate, discountRate, years, cash, debt, sharesOutstanding);
    if (t <= 0)
        return fairPrice;
    return fairPrice * Math.pow((1 + discountRate / 100), t);
}
exports.calculateProjectionDCF = calculateProjectionDCF;
//# sourceMappingURL=fair-price-dcf.js.map